import { AnnotationLineItemT } from "./AnnotationLineItemT";


export const SmsAnnotationObject: SmsAnnotationT = {
    notes: "",
    title: "",
    words: []
}

export interface AnnotationTokens {
    color?: string
    start: number;
    end: number;
    tag?: string
    tokens: string[];
}

export interface SmsAnnotationT extends AnnotationLineItemT {
    notes: string
    words: Array<AnnotationTokens>
}